import { cn } from "@fmc-digital/ui";
import { useTranslation } from "@fmc-digital/i18n";
import deviceTimeWarningIcon from "./device-time-warning.svg";

const MAC_INSTRUCTIONS_URL =
  "https://support.apple.com/guide/mac-help/set-the-date-and-time-automatically-mchlp2996/mac#:~:text=On%20your%20Mac%2C%20choose%20Apple,may%20need%20to%20scroll%20down.)&text=Turn%20on%20%E2%80%9CSet%20time%20and,automatically%20using%20your%20current%20location.%E2%80%9D";
const WINDOWS_INSTRUCTIONS_URL =
  "https://support.microsoft.com/en-us/windows/how-to-set-your-time-and-time-zone-dfaa7122-479f-5b98-2a7b-fa0b6e01b261";

/**
 * "Device Time Not Synced" inline alert.
 * Figma: ACP - Login Redesign - Handoff, node 6457:22443.
 * Shown when the device clock does not match the server clock
 * (see utils/clockSync.ts), blocking login while visible.
 */
export function LocalTimeErrorBanner() {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "flex w-full flex-col items-start justify-center gap-2 rounded-lg bg-error-container px-4 py-3",
      )}
      data-testid="local-time-error-banner"
    >
      <div className="flex w-full items-center gap-3">
        <div className="relative size-[22px] shrink-0" aria-hidden="true">
          <img src={deviceTimeWarningIcon} alt="" className="absolute inset-0 block size-full max-w-none" />
        </div>
        <p className="min-w-px flex-1 font-poppins text-[15px] font-medium leading-normal text-on-error-container">
          {t("auth.login.localTimeErrorTitle")}
        </p>
      </div>
      <div className="w-full font-poppins text-[13px] leading-[20px] text-on-surface">
        <p className="m-0">{t("auth.login.localTimeErrorBody")}</p>
        <p className="m-0">{t("auth.login.localTimeErrorDetail")}</p>
      </div>
      <div className="flex w-full items-center gap-4 font-poppins text-[12px] leading-[18px] text-primary">
        <a
          href={MAC_INSTRUCTIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="underline decoration-solid [text-underline-position:from-font]"
        >
          {t("auth.login.localTimeErrorMac")}
        </a>
        <a
          href={WINDOWS_INSTRUCTIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="underline decoration-solid [text-underline-position:from-font]"
        >
          {t("auth.login.localTimeErrorWindows")}
        </a>
      </div>
    </div>
  );
}
